import Swiper from 'swiper/bundle';

export default function blockLogotypes() {
    document.querySelectorAll(
        '.logotypes-slider:not(.logotypes-slider--disabled)' ).
        forEach( function( slider ) {
            const swiper = new Swiper( slider, {
                speed: 1000,
                loop: true,
                spaceBetween: 2,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: true,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: Math.ceil( parseInt( slider.dataset.cols ) / 2 ),
                        loopAdditionalSlides: 0,
                    },
                    // when window width is >= 480px
                    1200: {
                        slidesPerView: parseInt( slider.dataset.cols ),
                    },
                },
            } );
        } );
}